import apiAuth from 'src/clients/apiAuth';
import constants from 'src/constants/constants';
import { format } from 'date-fns';

export default {
  getDemands() {
    return apiAuth({
      method: 'GET',
      baseURL: constants.url.demandService.baseUrl,
      url: constants.url.demandService.api.getActiveDemands,
    }).then((res) => res.data);
  },
  downloadDemands(fields, diffTax, active) {
    return apiAuth({
      method: 'GET',
      baseURL: constants.url.demandService.baseUrl,
      url: constants.url.demandService.api.getActiveDemands,
      params: {
        fields: fields,
        active: active,
        condition: 'new',
        diffTax: diffTax,
      },
      responseType: 'blob',
      headers: {
        Accept: 'text/csv',
      },
    }).then((response) => {
      const date = new Date();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', format(date, 'yyyy-MM-dd_HH-mm-ss') + '_active-demands.csv');
      link.click();
      window.URL.revokeObjectURL(url);
    });
  },
  downloadDemandsGrouped(fields, diffTax, active) {
    return apiAuth({
      method: 'GET',
      baseURL: constants.url.demandService.baseUrl,
      url: constants.url.demandService.api.getDemandsGroupedBySku,
      params: {
        fields: fields,
        active: active,
        condition: 'new',
        diffTax: diffTax,
      },
      responseType: 'blob',
      headers: {
        Accept: 'text/csv',
      },
    }).then((response) => {
      const date = new Date();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', format(date, 'yyyy-MM-dd_HH-mm-ss') + '_active-demands.csv');
      link.click();
      window.URL.revokeObjectURL(url);
    });
  },
  getDemandsGroupedBySku() {
    return apiAuth({
      method: 'GET',
      baseURL: constants.url.demandService.baseUrl,
      url: constants.url.demandService.api.getDemandsGroupedBySku,
    }).then((res) => res.data);
  },
  createStrategicDemand(productKey, variantKey, amount, diffTaxPossible) {
    return apiAuth({
      method: 'POST',
      baseURL: constants.url.demandService.baseUrl,
      url: constants.url.demandService.api.createStrategicDemand,
      data: {
        productKey: productKey,
        variantKey: variantKey,
        amount: amount,
        diffTaxPossible: diffTaxPossible,
      },
    }).then((res) => res.data);
  },
  fulfillDemand({
    demandId,
    purchaseOfferId,
    acceptedPrice,
    acceptedCurrency,
    deliveryDate,
    creditorId,
    orderNumber,
    lineNumber,
    productKey,
    variantKey,
    differentialTaxation,
    userId,
  }) {
    return apiAuth({
      method: 'POST',
      baseURL: constants.url.demandService.baseUrl,
      url: constants.url.demandService.api.fulfillDemand,
      data: {
        demandId: demandId,
        purchaseOfferId: purchaseOfferId,
        acceptedPrice: acceptedPrice,
        acceptedCurrency: acceptedCurrency,
        deliveryDate: deliveryDate,
        creditorId: creditorId,
        orderNumber: orderNumber,
        lineNumber: lineNumber,
        productKey: productKey,
        variantKey: variantKey,
        differentialTaxation: differentialTaxation,
        userId: userId,
      },
    }).then((res) => res.data);
  },
  cancelDemand(demandId) {
    if (!demandId) {
      throw new Error('Demand ID is required');
    }
    return apiAuth({
      method: 'PATCH',
      baseURL: constants.url.demandService.baseUrl,
      url: constants.url.demandService.api.cancelDemand(demandId),
    }).then((res) => res.data);
  },
  getLastUpdateTimestamp() {
    return apiAuth({
      method: 'GET',
      baseURL: constants.url.demandService.baseUrl,
      url: constants.url.demandService.api.getLastUpdateTimestamp,
    }).then((res) => res.data);
  },
};
